import React from 'react';

const BetaStamp = () => <div className="beta-div-container">BETA</div>;

export default BetaStamp;
